// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__3I15J","Logo":"Modal_Logo__CmI-4","Headline":"Modal_Headline__1WXty","Content":"Modal_Content__1f6GR","CloseBtn":"Modal_CloseBtn__k7hld"};